'use strict';

angular.module('shiftTraderApp')
  .controller('EmployeesCtrl', function ($scope, users, positions, me, $uibModal, toastr,
                                         $location, Users, org, ServerUrls, Session,
                                         UserPermissionsService, PermissionSetsStore) {
    $scope.me = me;
    $scope.org = org;
    $scope.departments = $scope.org.departments;

    $scope.state = {
      currentPositionIndex: -1,
      rawPermissions: null,
      derivedPermissions: null,
      showPayRatesInfoBar: !lodash.has($scope.me.completed_tours, 'pay-rates-information-tour')
    };

    function processRawPermissions() {
      $scope.state.derivedPermissions = {
        canResendActivation: $scope.state.rawPermissions['users.resend_activation'],
        canAddEmail: $scope.state.rawPermissions['users.update_email_address'],
        canViewAllPermissions: $scope.state.rawPermissions['permission_sets.view_all_in_org'],
        canLoadPayRatesTemplate: $scope.state.rawPermissions['user_pay_rates.view'] && $scope.state.rawPermissions['user_pay_rates.create'] && $scope.state.rawPermissions['user_pay_rates.set_ineffective'],
        canLoadPositionAssignment: $scope.state.rawPermissions['users_positions.view_in_org']
      };
    }

    var permissionsToLookUp = [
      'users.resend_activation',
      'users.update_email_address',

      'users_positions.view_in_org',

      'reports.employees',
      'reports.weekly_hours',

      'permission_sets.view_all_in_org',

      'user_pay_rates.view',
      'user_pay_rates.create',
      'user_pay_rates.set_ineffective'
    ];

    UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();


        addPermissionDataToUsers();
      });

    $scope.employee_report_url = ServerUrls.current.railsApi + 'reports/employees?access_token=' + Session.getAccessToken() + '&organization_id=' + Session.getCurrentOrgId();

    var addStatesToUser = function(u) {
      if (_.isNull(u.email)) {
        u._status = 'Email Needed';
      } else {
        if (_.isNull(u.activated_at)) {
          if (_.isNull(u.activation_sent_at)) {
            u._status = 'Not Yet Invited';
          } else {
            u._status = 'Not Activated'
          }
        } else if (!u.$curMemb().active) {
          u._status = 'Inactive';
        } else {
          u._status = 'Activated';
        }
      }
      return u;
    };

    function addPermissionDataToUsers() {
      if ($scope.state.derivedPermissions.canViewAllPermissions) {
        PermissionSetsStore.getRecordsForOrgId($scope.org.id)
          .then(function(records) {
            $scope.permissionSets = records;

            _.each($scope.users, function(u) {
              var memb = _.find(u.memberships, {organization_id: org.id});

              if (memb) {
                if (memb.role) {
                  if (memb.role === 'employee') {
                    u._role = 'Employee';
                    u._roleVal = 100;
                  } else if (memb.role === 'admin') {
                    u._role = 'Admin';
                    u._roleVal = 0;
                  } else if (memb.role === 'manager') {
                    // TODO: remove manager name when permissions fully rolled out
                    u._role = 'Manager';
                    u._roleVal = 50;
                  }
                } else if (memb.permission_set_id) {
                  var permSet = _.find($scope.permissionSets, {id: memb.permission_set_id});

                  if (permSet) {
                    u._role = permSet.name;
                    u._roleVal = 10;
                  }
                }
              }
            });
          });
      } else {
        // if they can't see all permissions sets, just put n/a
        _.each($scope.users, function(u) {
          u._role = 'n/a';
          u._roleVal = 10;
        });
      }

    }

    $scope.users = _.map(users, addStatesToUser);
    $scope.positions = _.map(positions, function(pos) {

      if (_.isNull(pos.department_id)) {
        pos.department = {
          name: 'Uncategorized'
        };
      } else {
        var dept = _.find($scope.departments, {id: pos.department_id});
        if (!_.isUndefined(dept)) {
          pos.department = dept;
        }
      }

      return pos;
    });

    $scope.positions.unshift({id: -1, name: 'All Positions'});
    $scope.showSelector = 'true';
    $scope.sortField = 'first_name';
    $scope.sortDir = '+';

    $scope.goToProfile = function(emp_id) {
      $location.path('profile/' + emp_id);
    };

    $scope.changeSort = function(fieldName) {
      if (fieldName === $scope.sortField) {
        if ($scope.sortDir === '+') {
          $scope.sortDir = '-';
        } else {
          $scope.sortDir = '+';
        }
      } else {
        $scope.sortField = fieldName;
        $scope.sortDir = '+';
      }
    };

    var calculateEmployeesToShow = function() {
      $scope.activeEmployees = _.where($scope.users, function(u) {
        return u.memberships[0].active === 1;
      });

      $scope.inactiveEmployees = _.where($scope.users, function(u) {
        return u.memberships[0].active === 0;
      });

      if ($scope.showSelector === 'true') {
        $scope.currentList = $scope.activeEmployees;
      } else {
        $scope.currentList = $scope.inactiveEmployees;
      }

      $scope.state.currentPositionIndex = -1;
      $scope.usersByPosition = {};
      _.each($scope.positions, function(pos) {
        $scope.usersByPosition[pos.id] = [];
        $scope.usersByPosition[pos.id] = _.where($scope.currentList, function(usr) {
          return _.any(usr.users_positions, function(up) {
            return up.position.id === pos.id;
          });
        });
      });

      $scope.currentDataSet = $scope.currentList;
    };

    calculateEmployeesToShow();
    $scope.currentList = $scope.activeEmployees;


    $scope.$watch('state.currentPositionIndex', function(val) {
      if (_.isUndefined(val) || val === -1) {
        $scope.currentDataSet = $scope.currentList;
      } else {
        $scope.currentDataSet = $scope.usersByPosition[val];
      }
    });

    $scope.groupByDept = function(pos) {
      var idx = _.findIndex($scope.departments, {id: pos.department_id});

      if (idx > -1) {
        return $scope.departments[idx].name;
      } else {
        return '';
      }
    };

    $scope.setShow = function(val) {
      if (val === 'true') {
        $scope.currentList = $scope.activeEmployees;
      } else {
        $scope.currentList = $scope.inactiveEmployees;
      }
      $scope.showSelector = val;
      calculateEmployeesToShow();
    };

    $scope.openAddEmail = function(evt, user) {
      evt.preventDefault()
      evt.stopPropagation()

      var modalInstance = $uibModal.open({
        size: 'md',
        templateUrl: 'views/editProfileVitals.html',
        controller: 'EditProfileVitalsCtrl',
        resolve: {
          params: function() {
            return {
              me: me,
              user: user,
              org: $scope.org,
              focus: 'email'
            };
          }
        }
      });
      modalInstance.result.then(function(result) {
          console.log('closed edit profile vitals with result');
          console.log(result);
          if (!_.isUndefined(result)) {
            var idx = _.findIndex($scope.users, function(usr) {
              return usr.id === result.id;
            });

            if (idx >= 0) {
              $scope.users[idx] = addStatesToUser(result);
              calculateEmployeesToShow();
            } else {
              console.log('what happened? idx is -1');
            }

          }
        },
        function(reason) {
          console.log('dismissed explanation with reason ' + reason);
        });
    };

    $scope.resendActivation = function(evt, user) {
      evt.preventDefault()
      evt.stopPropagation()

      user.$resendActivationEmail()
        .then(function() {
          toastr.success('Activation e-mail resent.', 'Success');
        }, function() {
          toastr.error('Unable to resend activation e-mail. Please try again later.', 'Error');
        });
    };

    $scope.resendAllActivations = function() {
      Users.resendActivationByOrg($scope.me.memberships[0].organization_id)
        .then(function() {
          toastr.success('Activations successfully re-sent.', 'Success');
        }, function() {
          toastr.error('Experienced an error while resending activations. Please try again later.', 'Error');
        });
    };

    $scope.openCreateMultiUser = function() {
      var modalInstance = $uibModal.open({
        size: 'md',
        templateUrl: 'views/createMultiUser.html',
        controller: 'CreateMultiUserDialogCtrl',
        resolve: {
          org: function() {
            return org;
          },
          allPositions: ['Positions', function(Positions) {
            return Positions.getAllInOrg();
          }]
        }
      });
      modalInstance.result.then(function(result) {
          result = lodash.map(result, addStatesToUser)
          $scope.users = result.concat($scope.users)
          addPermissionDataToUsers();
          calculateEmployeesToShow();

          $scope.$broadcast('addedEmployees', $scope.users)
        },
        function(reason) {
          console.log('dismissed multi create with reason ' + reason);
        });
    };

    $scope.closeInfoBar = function () {
      $scope.me.$finishTour('pay-rates-information-tour')
      $scope.state.showPayRatesInfoBar = false
    }
  });
